"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cumsumTransformDependencies = void 0;
var _dependenciesAddGenerated = require("./dependenciesAdd.generated.js");
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _dependenciesUnaryPlusGenerated = require("./dependenciesUnaryPlus.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var cumsumTransformDependencies = exports.cumsumTransformDependencies = {
  addDependencies: _dependenciesAddGenerated.addDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  unaryPlusDependencies: _dependenciesUnaryPlusGenerated.unaryPlusDependencies,
  createCumSumTransform: _factoriesAny.createCumSumTransform
};